module.exports = __webpack_public_path__ + "img/rice_grain.be5030ca.webp";